<template>
  <div class="outer-box max-w-xl">
    <h4>Get ISV Details for Location</h4>

    <b-alert show variant="info" class="text-left m-3">
      Provides details such as the Twilio SID (both new and old) and the ISV mode status.
    </b-alert>

    <div class="inner-box" style="text-align: left; width: 500px">
      <input class="hl_input--wrap" type="text" placeholder="Location ID" v-model="locationId" />
      <button class="btn btn-primary mt-4" @click="fetchISVInfoForLocation">
        <moon-loader v-if="processing" :loading="true" size="21px" color="#fafafa" />
        <span v-else> Fetch ISV Data </span>
      </button>
      <pre v-if="response" style="background-color: #f2f7fa; padding: 16px; margin-top: 16px">{{
        response
      }}</pre>
    </div>
  </div>
</template>

<script>
import { SaasService } from "@/services";

export default {
  data() {
    return {
      locationId: "",
      processing: false,
      response: null,
    };
  },
  methods: {
    isValidLocationId(id) {
      return id && /^[a-zA-Z0-9]{10,50}$/.test(id.trim());
    },
    fetchISVInfoForLocation() {
      if (!this.isValidLocationId(this.locationId)) {
        this.response = { error: "Invalid Location ID. Enter only the location ID, not a URL." };
        return;
      }
      this.processing = true;
      SaasService.getISVInfoForLocation(this.locationId.trim())
        .then((response) => {
          this.response = response.data;
        })
        .catch((error) => {
          this.response = error.response?.data || { error: error.message };
        })
        .finally(() => {
          this.processing = false;
        });
    },
  },
};
</script>

<style></style>
